export default __webpack_public_path__ + "static/media/vehicleMarkerCallout_Yay.413ceacd.svg";